export default "__VITE_ASSET___H0zECa$__"